/**
 * When the number of cells in a row changes (subdivision toggle, triplet
 * on/off), remap existing armed cells to the nearest position in the new
 * row. Collisions are OR-collapsed.
 *
 * Zooming in (e.g. 8 → 16) always maps each old cell to exactly one new
 * cell; zooming out (16 → 8) may collapse neighbours to the same slot.
 * Triplet ↔ straight transitions are the fuzzy case — cells snap to the
 * nearest and may collapse. This is a deliberate trade-off over wiping
 * the grid entirely.
 */
export function remapRowToSteps(row: boolean[], newSteps: number): boolean[] {
  const next = Array<boolean>(newSteps).fill(false)
  if (newSteps <= 0 || row.length === 0) return next
  for (let i = 0; i < row.length; i++) {
    if (!row[i]) continue
    const t = i / row.length
    const j = Math.min(newSteps - 1, Math.round(t * newSteps))
    next[j] = true
  }
  return next
}

export function remapGridToSteps(
  grid: boolean[][],
  newSteps: number,
): boolean[][] {
  return grid.map((row) => remapRowToSteps(row, newSteps))
}
